import React, { useEffect, useState  } from "react";
import { useNavigate } from "react-router-dom";




const vendorTemplates = [
  `<div class="vendor-block">
    <h3>[Vendor] – Trusted Local Expertise</h3>
    <p>Based in <strong>[City]</strong>, <strong>[Vendor]</strong> is a well-known name in the solar industry, offering tailored solar solutions for residential and commercial clients. With over <strong>6+ </strong> years of experience, they are known for their customer-centric approach, on-time project completion, and competitive pricing.</p>
  <ul>
      <li>Rooftop solar installations</li>
      <li>Net metering assistance</li>
      <li>Solar panel maintenance and support</li>
    </ul>
    <p>[WEBSITE][PHONE]</p>
  </div>`,
  `<div class="vendor-block">
    <h3>[Vendor] – Affordable Solar for Everyone</h3>
    <p><strong>[Vendor]</strong> specializes in providing cost-effective solar systems without compromising on quality. They work with Tier-1 solar panel installer and have a proven track record of successful installations across <strong>Rajasthan</strong>.</p>
  <ul>
      <li>Budget-friendly packages</li>
      <li>Government subsidy assistance</li>
      <li>Quick turnaround time</li>
    </ul>
    <p>[WEBSITE][PHONE]</p>
  </div>`,
  `<div class="vendor-block">
    <h3>[Vendor] – End-to-End Solar Solutions</h3>
    <p>From consultation to commissioning, <strong>[Vendor]</strong> offers complete EPC (Engineering, Procurement, and Construction) services. They cater to homes, industries, and institutions looking to make the switch to solar with minimal hassle.</p>
  <ul>
      <li>End-to-end service model</li>
      <li>High-efficiency solar panels</li>
      <li>After-sales service and AMC options</li>
    </ul>
    <p>[WEBSITE][PHONE]</p>
  </div>`,
  `<div class="vendor-block">
    <h3>[Vendor] – High-Quality Installations</h3>
    <p><strong>[Vendor]</strong> stands out for its quality workmanship and certified solar technicians. Every installation is carried out with attention to detail, ensuring long-term performance and reliability.</p>
  <ul>
      <li>Skilled and certified workforce</li>
      <li>Use of top-grade materials</li>
      <li>Excellent customer reviews</li>
    </ul>
    <p>[WEBSITE][PHONE]</p>
  </div>`,
  `<div class="vendor-block">
    <h3>[Vendor] – Innovative Solar Technology</h3>
    <p>With a focus on innovation, <strong>[Vendor]</strong> incorporates smart energy management systems into its solar solutions. They provide real-time monitoring and analytics for users to track their energy savings and system performance.</p>
  <ul>
      <li>IoT-based solar monitoring</li>
      <li>Battery and hybrid solutions</li>
      <li>Custom design and layout planning</li>
    </ul>
    <p>[WEBSITE][PHONE]</p>
  </div>`,
  `<div class="vendor-block">
    <h3>[Vendor] – Government-Approved Vendor</h3>
     <p>Recognized by <strong>[State Government/Ministry of New and Renewable Energy]</strong>, <strong>[Vendor]</strong> is an empaneled solar vendor that helps clients benefit from government subsidies and schemes.</p>
  <ul>
      <li>Hassle-free subsidy application</li>
      <li>MNRE-approved products</li>
      <li>Transparent pricing</li>
    </ul>
    <p>[WEBSITE][PHONE]</p>
  </div>`,
  `<div class="vendor-block">
    <h3>[Vendor] – Residential & Commercial Experts</h3>
    <p>Whether you are installing solar at home or for your business, <strong>[Vendor]</strong> brings expertise in both domains. Their flexible financing options and scalable solutions make them a preferred choice.</p>
  <ul>
      <li>EMI and lease options</li>
      <li>On-grid and off-grid systems</li>
      <li>Customized solar plant sizing</li>
    </ul>
    <p>[WEBSITE][PHONE]</p>
  </div>`,
  `<div class="vendor-block">
    <h3>[Vendor] – Local Presence, Nationwide Reach</h3>
    <p>Though headquartered in <strong>[City]</strong>, <strong>[Vendor]</strong> operates across multiple cities, making quality solar accessible in even remote areas. Their wide network ensures quick service and support, wherever you are.</p>
  <ul>
      <li>Pan-India installation services</li>
      <li>Local service centers</li>
      <li>Quick response time</li>
    </ul>
    <p>[WEBSITE][PHONE]</p>
  </div>`,
];

function fillTemplate(template, vendor) {
  const name = vendor.name || "Unnamed Vendor";
  const city = vendor.city || "Unknown City";

  const website = vendor.website
    ? `<strong>Website:</strong> <a href="${vendor.website}" target="_blank" rel="noopener noreferrer" style="color:#0a5fff;">${vendor.website}</a><br>`
    : "";

  const phone = vendor.phone
    ? `<strong>Phone:</strong> <a href="tel:${vendor.phone}" style="color:#0a5fff;">${vendor.phone}</a>`
    : "";

  const blockStyle = `
    style="background:#fff;border:1px solid #eee;padding:20px;border-radius:10px;
           box-shadow:0 2px 6px rgba(0,0,0,0.05);margin-bottom:20px;"`;

  const h3Style = `style="font-size:20px;color:#0a5fff;"`;
  const pStyle = `style="font-size:15px;color:#333;"`;
  const liStyle = `style="font-size:15px;color:#333;"`;
  const ulStyle = `style="padding-left:18px;"`;

  return template
    .replace('<div class="vendor-block">', `<div ${blockStyle}>`)
    .replace(/<h3>/g, `<h3 ${h3Style}>`)
    .replace(/<p>/g, `<p ${pStyle}>`)
    .replace(/<ul>/g, `<ul ${ulStyle}>`)
    .replace(/<li>/g, `<li ${liStyle}>`)
    .replace(/\[Vendor\]/g, name)
    .replace(/\[City\]/g, city)
    .replace("[WEBSITE]", website)
    .replace("[PHONE]", phone);
}


const vendorBlockStyle = `
.vendor-block {
  background: #fff;
  border: 1px solid #eee;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  margin-bottom: 20px;
}
.vendor-block h3 {
  font-size: 20px;
  color: #0a5fff;
}
.vendor-block p, .vendor-block li {
  font-size: 15px;
  color: #333;
}
.vendor-block ul {
  padding-left: 18px;
}
.vendor-block a {
  color: #0a5fff;
}
`;

const GenerateTemplate = () => {
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [limit, setLimit] = useState("");
  const [vendors, setVendors] = useState([]);
  const [htmlOutput, setHtmlOutput] = useState("");
  const [loading, setLoading] = useState(false);
  const [blogTitle, setBlogTitle] = useState("");
  const [blogBrief, setBlogBrief] = useState("");
const navigate = useNavigate();


useEffect(() => {
  fetch("https://api.solarstation.in/stateWithCities/c/getall")
    .then((res) => res.json())
    .then((data) => {
      const sortedCities = (data || []).sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      setCities(sortedCities);
    });
}, []);




const handleGenerate = async () => {
  if (!selectedCity || !limit) {
    alert("Please select a city and enter number of vendors.");
    return;
  }

  setLoading(true);
  setVendors([]);
  setHtmlOutput("");

  try {
    const res = await fetch(
      `https://api.solarstation.in/vendor/getAllVendors?city=${selectedCity}&limit=${limit}`
    );
    const json = await res.json();
    let fetchedVendors = json?.data || [];

    fetchedVendors = fetchedVendors.map((v) => ({
      ...v,
      phone: v.phone || v?.branches?.[0]?.phone || "",
      website: v.website || v?.branches?.[0]?.website || "",
    }));

    const selectedVendors = fetchedVendors
      .sort(() => 0.5 - Math.random())
      .slice(0, parseInt(limit));

    const titleText = `Top ${limit} Solar Vendors in ${selectedCity}`;
    const briefText = `Thinking of switching to solar in ${selectedCity}? With abundant sunshine and rising electricity costs, there's never been a better time to make the move. But choosing the right solar installer is just as important as the panels themselves. To make your search easier, we’ve shortlisted the Top ${limit} Solar Installers in ${selectedCity} known for their quality, reliability, and customer satisfaction. Let’s dive in!`;

    setBlogTitle(titleText);
    setBlogBrief(briefText);

    const intro = `<h1><strong>${titleText}</strong></h1><p><br></p><p>${briefText}</p><p><br></p>`;

  
   

    const generatedHTML =
      intro +
      selectedVendors
        .map((vendor) => {
          const randomTemplate =
            vendorTemplates[Math.floor(Math.random() * vendorTemplates.length)];
          return fillTemplate(randomTemplate, vendor);
        })
        .join("\n");

    setVendors(selectedVendors);
    setHtmlOutput(generatedHTML);
  } catch (err) {
    console.error("Failed to fetch vendors:", err);
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="min-h-screen bg-white px-4 py-8">
      <style>{vendorBlockStyle}</style>

      <h1 className="text-2xl font-bold mb-6 text-center">Solar Vendor Template Generator</h1>

      <div className="max-w-xl mx-auto space-y-4 mb-8">
        <div>
          <label className="block font-semibold mb-1">Select City</label>
          <select
            className="w-full border px-3 py-2 rounded"
            value={selectedCity}
            onChange={(e) => setSelectedCity(e.target.value)}
          >
            <option value="">-- Select City --</option>
            {cities.map((c, i) => (
              <option key={i} value={c.name}>
                {c.name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block font-semibold mb-1">Number of Vendors</label>
          <input
            type="number"
            className="w-full border px-3 py-2 rounded"
            value={limit}
            onChange={(e) => setLimit(e.target.value)}
            placeholder="e.g. 5"
          />
        </div>

        <button
          onClick={handleGenerate}
          disabled={loading}
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
        >
          {loading ? "Generating..." : "Generate Templates"}
        </button>
      </div>

      {/* Rendered HTML Preview */}
      {vendors.length > 0 && (
        <div className="max-w-3xl mx-auto space-y-6 mb-10">
          <div dangerouslySetInnerHTML={{ __html: htmlOutput }} />
        </div>
      )}

{htmlOutput && (
  <div className="max-w-4xl mx-auto mb-6 flex justify-end">
    <button
      onClick={() => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlOutput, "text/html");

        // Remove title if matches any heading tag (h1-h6)
        if (blogTitle) {
          const headings = doc.querySelectorAll("h1, h2, h3, h4, h5, h6");
          headings.forEach((el) => {
            if (el.textContent.trim().toLowerCase() === blogTitle.trim().toLowerCase()) {
              el.remove();
            }
          });
        }

        // Remove brief description from paragraphs
      if (blogBrief) {
  const paragraphs = doc.querySelectorAll("p");
  paragraphs.forEach((p) => {
    const normalizedP = p.textContent.trim().toLowerCase();
    const normalizedBrief = blogBrief.trim().toLowerCase();

    // Use includes instead of exact match
    if (normalizedP.includes(normalizedBrief)) {
      p.remove();
    }
  });
}

        // Get cleaned HTML
        const cleanedDescription = doc.body.innerHTML.trim();

        const blogData = {
          title: blogTitle,
          briefDescription: blogBrief,
          description: cleanedDescription,
        };

        sessionStorage.setItem("generatedBlog", JSON.stringify(blogData));
        navigate("/blogManagement/add");
      }}
      className="bg-gray-700 text-white px-6 py-2 rounded hover:bg-gray-600 transition"
    >
      Add Blog
    </button>
  </div>
)}





      {/* Final HTML Output */}
      {htmlOutput && (
        <div className="max-w-4xl mx-auto mb-20">
          <label className="block text-lg font-semibold mb-2">Full HTML Output</label>
          <textarea
            className="w-full border p-4 rounded text-sm font-mono"
            rows={20}
            value={htmlOutput}
            readOnly
          />
        </div>
      )}
    </div>
  );
};

export default GenerateTemplate;
